var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.avatarClasses},[_c('div',{class:_vm.avatarImgClasses},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}}):_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }